import React from 'react'
import './index.scss'
import classNames from 'classnames'
import Select, { components } from 'react-select'
import AsyncSelect from 'react-select/async'
import { Icon } from '@winnin/winnin_ui.components.icon'
import { Title } from '@winnin/winnin_ui.components.title'

import Thumbnail from 'components/Thumbnail'
import { COLORS } from 'consts'

import IllustrationIdea from '../../assets/images/svg/illustration-idea.svg'
import LockerIcon from '../../assets/images/svg/locker.svg'

const getTheme = (theme, customThemeColors) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: COLORS.primary_light2,
    primary50: COLORS.primary_light2,
    primary: COLORS.primary,
    ...customThemeColors,
  },
})

const selectText = e => {
  if (window.getSelection) {
    const range = document.createRange()
    range.selectNode(document.getElementById(e.target.id))
    window.getSelection().removeAllRanges()
    window.getSelection().addRange(range)
  }
}

const Option = props => {
  return (
    <section className="container-option">
      <components.Option {...props} />
      {props.isDisabled && (
        <div id="popover-language-content" className={`popover-language-content`}>
          <Thumbnail className="image" src={IllustrationIdea} />
          <Title className="text" tag="h5">
            Get insights in other languages! Upgrade to gain access.
          </Title>
          <Title variation="primary" tag="h5" weight="bold">
            Contact us for upgrading
          </Title>
          <p id={`text${props.innerProps.id}`} onClick={e => selectText(e)} className="email">
            cs@winnin.com
          </p>
        </div>
      )}
    </section>
  )
}

const TooltipOption = props => {
  return props.data.disabled ? (
    <div
      className={`tooltipped tooltipped-n tooltipped-multiline option-disabled filter-post`}
      aria-label={`Get insights in other languages! Upgrade to gain access.`}
    >
      {props.data.label}
    </div>
  ) : (
    <components.Option {...props} />
  )
}

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected
      ? COLORS.base_color2
      : state.isFocused
        ? COLORS.base_color2
        : state.isDisabled
          ? COLORS.gray_light1
          : COLORS.gray_dark2,
    backgroundImage: state.isDisabled ? `url(${LockerIcon})` : 'none',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '190px center',
    userSelect: 'auto',
    '.reactSelect-sublabel': {
      color: state.isFocused ? COLORS.base_color2 : COLORS.$gray_light1,
    },
    '@media only screen and (max-width: 768px)': {
      ...provided['@media only screen and (max-width: 768px)'],
      fontSize: '14px',
    },
  }),
  control: provided => ({
    ...provided,
    boxShadow: 'none',
    borderColor: COLORS.gray_light1,
  }),
  menu: provided => ({
    ...provided,
    zIndex: 10,
    '@media only screen and (max-width: 768px)': {
      ...provided['@media only screen and (max-width: 768px)'],
      zIndex: 10000, // To stand above the navigation bar
    },
  }),
  groupHeading: provided => ({
    ...provided,
    fontWeight: 900,
  }),
  placeholder: provided => ({
    ...provided,
    '@media only screen and (max-width: 768px)': {
      ...provided['@media only screen and (max-width: 768px)'],
      fontSize: '14px',
    },
  }),
  singleValue: provided => ({
    ...provided,
    '@media only screen and (max-width: 768px)': {
      ...provided['@media only screen and (max-width: 768px)'],
      fontSize: '14px',
    },
  }),
}

const ReactSelect = props => {
  const {
    label,
    icon,
    containerClass,
    asyncSelect,
    customThemeColors,
    labelToTheLeft,
    isActive,
    withClear,
    onClearCallback,
  } = props
  const containerClasses = classNames('select-group', containerClass, { 'label-to-the-left': labelToTheLeft })
  const selectLabelClass = classNames('select-label', { active: isActive, 'with-clear': withClear })
  const SelectComponent = asyncSelect ? AsyncSelect : Select
  const formatOptionLabel = ({ label, subLabel }, { context, selectValue }) => {
    return !subLabel ? (
      label
    ) : (
      <>
        {label}
        {context === 'menu' && (
          <p className={`reactSelect-sublabel ${selectValue[0]?.label === label ? 'selected' : ''}`}>{subLabel}</p>
        )}
      </>
    )
  }
  return (
    <div className={containerClasses} data-testid={label}>
      <div className={selectLabelClass}>
        {label && <label>{label}</label>}
        {withClear && isActive && (
          <div
            className="select-label-clear-btn"
            onClick={e => {
              e.stopPropagation()
              onClearCallback()
            }}
          >
            Clear
          </div>
        )}
      </div>
      {icon ? (
        <div className="select-icon-group">
          <Icon icon={icon} className="select-icon" width={32} height={32} />
          <SelectComponent
            formatOptionLabel={formatOptionLabel}
            theme={theme => getTheme(theme, customThemeColors)}
            styles={customStyles}
            components={{ Option }}
            backspaceRemovesValue={false}
            className="filter"
            {...props}
          />
        </div>
      ) : (
        <SelectComponent
          formatOptionLabel={formatOptionLabel}
          theme={theme => getTheme(theme, customThemeColors)}
          className="filter"
          styles={customStyles}
          components={{ Option: TooltipOption }}
          backspaceRemovesValue={false}
          {...props}
        />
      )}
    </div>
  )
}

export default ReactSelect
